<ng-container>
    <app-data-table [columns]="cols" [data]="equipments" [isCardView]="false"  [isDeletable]="'/master/poc' | hasPermission: 'Delete'"  [showAddButton]="'/master/poc' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/poc' | hasPermission: 'Edit'"  [isView]="'/master/poc' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
        [title]="title" (onAdd)="addCriteria()" (editEventRow)="onUpdateCriteria($event)" (onLazyLoadData)="getCriteria($event)" [totalRecords]="totalRecords"
        (deleteEventRow)="showDeletePopup($event)" [url]="'/master/poc/criteria/'">
    </app-data-table>
</ng-container>

<!-- Reusable Dialog for Add/Edit/View -->
<app-reusable-dialog
    [(visible)]="showDialog"
    [config]="dialogConfig"
    [initialData]="formData"
    [viewMode]="viewMode"
    (onSubmit)="onSubmitCriteria($event)"
    (onCancel)="onCancelDialog()"
    (onClose)="onCloseDialog()">
</app-reusable-dialog>

<p-dialog header="Delete Criteria" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
    <div class="delete-dialog mt-3">
        <i class="pi pi-trash text-danger custom-delete-icon"></i>
        <span>Are you sure , you want to delete Criteria ?</span>
        <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteequipment()" class="mt-2">
        </p-button>
    </div>
</p-dialog>